import { Component, inject, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-connection-deletion-required',
  standalone: false,
  templateUrl: './connection-deletion-required.component.html',
  styleUrl: './connection-deletion-required.component.scss'
})
export class ConnectionDeletionRequiredComponent {

  private dialog = inject(MatDialogRef<ConnectionDeletionRequiredComponent>);

  streams: any[] = [];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    this.streams = data.streams;
  }

  close() {
    this.dialog.close();
  }
}
